// Shared geography lists for the Team Database (public form + staff console).

// All 50 Spanish provinces plus Ceuta and Melilla — includes the Canary
// Islands (Las Palmas, Santa Cruz de Tenerife).
export const PROVINCES = [
  'A Coruña', 'Álava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Ávila',
  'Badajoz', 'Barcelona', 'Bizkaia', 'Burgos', 'Cáceres', 'Cádiz', 'Cantabria',
  'Castellón', 'Ceuta', 'Ciudad Real', 'Córdoba', 'Cuenca', 'Gipuzkoa',
  'Girona', 'Granada', 'Guadalajara', 'Huelva', 'Huesca', 'Illes Balears',
  'Jaén', 'La Rioja', 'Las Palmas', 'León', 'Lleida', 'Lugo', 'Madrid',
  'Málaga', 'Melilla', 'Murcia', 'Navarra', 'Ourense', 'Palencia',
  'Pontevedra', 'Salamanca', 'Santa Cruz de Tenerife', 'Segovia', 'Sevilla',
  'Soria', 'Tarragona', 'Teruel', 'Toledo', 'Valencia', 'Valladolid',
  'Zamora', 'Zaragoza',
];

// Detailed town list kept for Alicante province (MST's home region); other
// provinces use a free-text town field.
export const ALICANTE_MUNICIPALITIES = [
  'Albatera','Alcoy (Alcoi)','Algorfa','Alicante','Almoradí','Altea',
  'Aspe','Benejúzar','Benijófar','Benidorm','Benissa','Bigastro',
  'Calpe (Calp)','Callosa de Segura','Castalla','Catral','Cocentaina',
  'Cox','Crevillente','Dénia','Dolores','El Campello','Elche (Elx)',
  'Elda','Finestrat','Formentera del Segura','Guardamar del Segura',
  'Ibi','Jávea (Xàbia)','L\'Alfàs del Pi','La Nucia',
  'Los Montesinos','Monóvar','Moraira','Mutxamel','Novelda',
  'Ondara','Orba','Orihuela','Orihuela Costa','Pedreguer','Petrer',
  'Pilar de la Horadada','Polop','Redován','Rojales',
  'San Juan de Alicante','San Miguel de Salinas','San Vicente del Raspeig',
  'Santa Pola','Teulada','Torrevieja','Villajoyosa (La Vila Joiosa)','Villena',
  'Other',
];

// Older teamDatabase docs predate the province field and were all Alicante.
export function teamProvince(team) {
  return team?.province || 'Alicante';
}

// teamDatabase holds Spanish clubs and schools only: they are the fixture
// opponents for UK teams touring Spain, and the sales prospects for Spain → UK
// tours. UK organisations are sales leads for tours *to* Spain and live in
// englishClubLeads instead, so no region here is ever outside Spain.
export const CANARY_PROVINCES = ['Las Palmas', 'Santa Cruz de Tenerife'];

export const REGIONS = ['Mainland Spain', 'Canary Islands'];

export function teamRegion(team) {
  return CANARY_PROVINCES.includes(teamProvince(team))
    ? 'Canary Islands'
    : 'Mainland Spain';
}

// Provinces to offer once a region is chosen; everything when it is not.
export function provincesFor(region) {
  if (region === 'Canary Islands') return CANARY_PROVINCES;
  if (region === 'Mainland Spain') return PROVINCES.filter((p) => !CANARY_PROVINCES.includes(p));
  return PROVINCES;
}
